<template>
  <div class="min-h-screen bg-slate-50 dark:bg-slate-900">
    <Navbar />

    <section class="container py-20 md:py-28">
      <div class="grid grid-cols-1 gap-8 md:grid-cols-12">
        <!-- Sidebar -->
        <!-- <aside class="space-y-6 md:col-span-4">
          <div
            class="p-5 bg-white border rounded-xl border-slate-200 dark:bg-slate-800 dark:border-slate-700"
          >
            <h4
              class="mb-4 text-base font-semibold text-slate-900 dark:text-white"
            >
              المتطلبات والموافقة
            </h4>

            <ul class="mb-2 space-y-3">
              <li class="flex items-start gap-2">
                <span
                  class="mt-0.5 inline-flex items-center justify-center rounded-full size-6 bg-secondary/30 text-primary"
                >
                  <i class="mdi mdi-check-bold text-[13px]"></i>
                </span>
                <div>
                  <p
                    class="text-sm font-medium text-slate-800 dark:text-slate-200"
                  >
                    بيانات صحيحة
                  </p>
                  <p class="text-xs text-slate-500">
                    تأكد من مطابقة السجل التجاري.
                  </p>
                </div>
              </li>
              <li class="flex items-start gap-2">
                <span
                  class="mt-0.5 inline-flex items-center justify-center rounded-full size-6 bg-secondary/30 text-primary"
                >
                  <i class="mdi mdi-check-bold text-[13px]"></i>
                </span>
                <div>
                  <p
                    class="text-sm font-medium text-slate-800 dark:text-slate-200"
                  >
                    رقم جوال مفعّل
                  </p>
                  <p class="text-xs text-slate-500">
                    سيصلك رمز تحقق عبر الرسائل.
                  </p>
                </div>
              </li>
              <li class="flex items-start gap-2">
                <span
                  class="mt-0.5 inline-flex items-center justify-center rounded-full size-6 bg-secondary/30 text-primary"
                >
                  <i class="mdi mdi-check-bold text-[13px]"></i>
                </span>
                <div>
                  <p
                    class="text-sm font-medium text-slate-800 dark:text-slate-200"
                  >
                    بريد رسمي
                  </p>
                  <p class="text-xs text-slate-500">
                    لإشعارات العقود والفواتير.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </aside> -->

        <!-- Main -->
        <div class="md:col-span-6 md:col-start-4">
          <div
            class="w-full max-w-2xl mx-auto p-6 bg-white border shadow-sm rounded-2xl border-slate-200 dark:border-slate-700 dark:bg-slate-800 md:p-8"
          >
            <h1
              class="mb-1 text-xl font-bold text-center text-slate-900 dark:text-white"
            >
              {{ t("login_title") }}
            </h1>
            <p
              class="mb-6 text-sm text-center text-slate-500 dark:text-slate-400"
            >
              {{ t("login_subtitle") }}
            </p>

            <!-- Tabs -->
            <div
              class="grid grid-cols-2 gap-2 mb-4"
              role="tablist"
              :aria-label="t('login_method_label')"
            >
              <button
                type="button"
                role="tab"
                :id="ids.tabMobile"
                :aria-controls="ids.panelMobile"
                :aria-selected="loginWith === 'mobile'"
                class="px-4 py-2 text-sm font-semibold transition border rounded-lg border-primary/60"
                :class="
                  loginWith === 'mobile'
                    ? 'router-link-active router-link-exact-active text-primary bg-secondary/20'
                    : 'border-slate-300 text-slate-700 hover:bg-slate-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700/40'
                "
                @click="loginWith = 'mobile'"
              >
                {{ t("login_tab_mobile") }}
              </button>
              <button
                type="button"
                role="tab"
                :id="ids.tabEmail"
                :aria-controls="ids.panelEmail"
                :aria-selected="loginWith === 'email'"
                class="px-4 py-2 text-sm font-semibold transition border rounded-lg border-primary/60"
                :class="
                  loginWith === 'email'
                    ? 'router-link-active router-link-exact-active text-primary bg-secondary/20'
                    : 'border-slate-300 text-slate-700 hover:bg-slate-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700/40'
                "
                @click="loginWith = 'email'"
              >
                {{ t("login_tab_email") }}
              </button>
            </div>

            <!-- Form -->
            <form
              @submit.prevent="onSubmit"
              class="grid grid-cols-1 gap-4"
              novalidate
            >
              <!-- Identifier -->
              <div
                v-show="loginWith === 'mobile'"
                role="tabpanel"
                :id="ids.panelMobile"
                :aria-labelledby="ids.tabMobile"
              >
                <BaseInput
                  :id="ids.inputMobile"
                  :label="t('login_mobile_label')"
                  v-model.trim="form.identifier"
                  inputmode="tel"
                  autocomplete="username"
                  :placeholder="t('login_mobile_placeholder')"
                  :maxlength="10"
                />
              </div>

              <div
                v-show="loginWith === 'email'"
                role="tabpanel"
                :id="ids.panelEmail"
                :aria-labelledby="ids.tabEmail"
              >
                <BaseInput
                  :id="ids.inputEmail"
                  :label="t('login_email_label')"
                  v-model.trim="form.identifier"
                  type="email"
                  inputmode="email"
                  autocomplete="username"
                  :placeholder="t('login_email_placeholder')"
                />
              </div>

              <!-- Password -->
              <div class="relative">
                <BaseInput
                  :id="ids.inputPassword"
                  :label="t('login_password_label')"
                  v-model="form.password"
                  type="password"
                  :placeholder="t('login_password_placeholder')"
                  autocomplete="current-password"
                />
              </div>

              <!-- Remember + Forgot -->
              <div class="flex items-center justify-between">
                <label
                  class="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-300"
                >
                  <input
                    type="checkbox"
                    v-model="remember"
                    class="rounded border-slate-300 text-primary focus:ring-primary"
                    @change="persistIdentifier"
                  />
                  <span class="whitespace-nowrap">{{ t("login_remember_me") }}</span>
                </label>
                <RouterLink
                  to="/forgot"
                  class="text-sm font-semibold text-primary hover:text-primary/90"
                >
                  {{ t("login_forgot_password") }}
                </RouterLink>
              </div>

              <!-- Submit -->
              <button
                type="submit"
                class="inline-flex items-center justify-center w-full px-4 py-3 text-base font-semibold text-white transition rounded-md bg-primary hover:bg-primary/90 disabled:opacity-60"
                :disabled="loading || !canSubmit"
              >
                <span v-if="!loading">{{ t("login_submit") }}</span>
                <span v-else class="inline-flex items-center gap-2">
                  <i class="text-xl mdi mdi-loading mdi-spin"></i>
                  {{ t("login_loading") }}
                </span>
              </button>

              <p
                class="mt-1 text-sm text-center text-slate-600 dark:text-slate-300"
              >
                {{ t("login_no_account") }}
                <RouterLink
                  to="/registerClient"
                  class="font-semibold text-primary hover:text-primary/90"
                >
                  {{ t("login_create_account") }}
                </RouterLink>
              </p>
            </form>
          </div>
        </div>
        <!-- /Main -->
        <Toast
          :show="toast.show"
          :type="toast.type"
          :message="toast.message"
          @update:show="toast.show = $event"
        />
      </div>
    </section>
  </div>
  <Footer />
</template>

<script setup>
import { reactive, ref, computed, onMounted, onBeforeUnmount } from "vue";
import { useRoute, useRouter } from "vue-router";
import api from "@/services/api";
import { applyFullAuthSession, clearAuthCookies } from "@/utils/authSession";
import { setVerifySessionFromApi } from "@/utils/pendingVerification";
import Navbar from "@/components/Navbar.vue";
import BaseInput from "@/components/BaseInput.vue";
import Footer from "@/components/Footer.vue";
import Toast from "@/components/Toast.vue";
import { messages, normalizeLang, getSavedLang } from "@/i18n";

const router = useRouter();
const route = useRoute();

const lang = ref(getSavedLang());
function t(key) {
  return (messages[lang.value] && messages[lang.value][key]) || key;
}

let _langObserver = null;
let _langHandler = null;

//  فقط
const ids = {
  tabMobile: "tab-mobile",
  panelMobile: "panel-mobile",
  tabEmail: "tab-email",
  panelEmail: "panel-email",
  inputMobile: "input-mobile",
  inputEmail: "input-email",
  inputPassword: "input-password",
};

// ما عاد عندنا أنواع مستخدمين، فـ ما في userTypes ولا selectedType

// حالة الواجهة
const loginWith = ref("mobile"); // 'mobile' أو 'email'
const remember = ref(true);
const loading = ref(false);

// نموذج البيانات
const form = reactive({
  identifier: "", // جوال أو إيميل حسب التاب
  password: "",
});

// الأخطاء
const errors = reactive({
  identifier: "",
  password: "",
});

const phoneRe = /^05\d{8}$/; // 05XXXXXXXX
const emailRe = /^\S+@\S+\.\S+$/;

const toast = reactive({
  show: false,
  type: "error", // success | error | info
  message: "",
});

function showToast(message, type = "error") {
  toast.message = message;
  toast.type = type;
  toast.show = true;
}
// function setCookie(name, value, days = 0) {
//   const expires = new Date();
//   expires.setDate(expires.getDate() + days);

//   const isHttps = window.location.protocol === "https:";

//   document.cookie =
//     `${name}=${encodeURIComponent(value)};` +
//     `expires=${expires.toUTCString()};` +
//     `path=/;` +
//     `samesite=lax` +
//     (isHttps ? `; secure` : ``);
// }
function setCookie(name, value, days = 0) {
  // let cookieStr = `${name}=${encodeURIComponent(value)}; path=/; Secure; SameSite=Strict`;
  const isHttps = window.location.protocol === "https:";
  let cookieStr =
    `${name}=${encodeURIComponent(value)};` +
    // `expires=${expires.toUTCString()};` +
    `path=/;` +
    `samesite=lax` +
    (isHttps ? `; secure` : ``);
  // If days > 0, add expiration. If days = 0, it's a session cookie
  if (days > 0) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    cookieStr += `; expires=${date.toUTCString()}`;
  }
  
  document.cookie = cookieStr;
}
function clearErrors() {
  errors.identifier = "";
  errors.password = "";
}

function validate() {
  clearErrors();

  if (!form.identifier) {
    errors.identifier =
      loginWith.value === "mobile"
        ? t("login_error_phone_required")
        : t("login_error_email_required");
  } else if (loginWith.value === "mobile" && !phoneRe.test(form.identifier)) {
    errors.identifier = t("login_error_phone_invalid");
  } else if (loginWith.value === "email" && !emailRe.test(form.identifier)) {
    errors.identifier = t("login_error_email_invalid");
  }

  if (!form.password) {
    errors.password = t("login_error_password_required");
  }

  // ✅ لو فيه أخطاء اعرضها في toast
  if (errors.identifier || errors.password) {
    const msg = errors.identifier || errors.password;
    showToast(msg, "error");
    return false;
  }

  return true;
}

const canSubmit = computed(() => {
  const okId =
    form.identifier &&
    (loginWith.value === "mobile"
      ? phoneRe.test(form.identifier)
      : emailRe.test(form.identifier));

  const okPwd = !!form.password;
  return okId && okPwd;
});

// تذكّر الإيميل / الجوال فقط (مو التوكن)
function persistIdentifier() {
  try {
    if (remember.value && form.identifier) {
      localStorage.setItem("login_identifier", form.identifier);
      localStorage.setItem("login_with", loginWith.value);
    } else {
      localStorage.removeItem("login_identifier");
      localStorage.removeItem("login_with");
    }
  } catch {
    // تجاهل أخطاء التخزين
  }
}

onMounted(() => {
  _langHandler = (e) => {
    const next = normalizeLang(e?.detail || "ar");
    if (next !== lang.value) lang.value = next;
  };
  window.addEventListener("app:lang", _langHandler, { passive: true });

  _langObserver = new MutationObserver((muts) => {
    for (const m of muts) {
      if (
        m.type === "attributes" &&
        (m.attributeName === "lang" || m.attributeName === "dir")
      ) {
        lang.value = normalizeLang(document.documentElement.lang || "ar");
      }
    }
  });
  _langObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["lang", "dir"],
  });

  // استرجاع المعرّف المخزّن (إن وُجد)
  try {
    const savedId = localStorage.getItem("login_identifier");
    const savedWith = localStorage.getItem("login_with");

    if (savedId) form.identifier = savedId;
    if (savedWith === "email" || savedWith === "mobile") {
      loginWith.value = savedWith;
    }
  } catch {
    // تجاهل
  }
});

onBeforeUnmount(() => {
  if (_langObserver) _langObserver.disconnect();
  if (_langHandler) window.removeEventListener("app:lang", _langHandler);
});

async function onSubmit() {
  if (loading.value) return;
  if (!validate()) return;

  loading.value = true;

  try {
    const payload = {
      identifier: form.identifier.trim(),
      password: form.password,
      token_name: "web",
      // type: "client",
    };

    const { data } = await api.post("/login", payload);

    if (!applyFullAuthSession(data)) {
      throw new Error("Token not found in response");
    }

    persistIdentifier();

    showToast(t("login_success"), "success");

    const requested =
      (typeof route.query.redirect === "string" && route.query.redirect) ||
      (typeof route.query.to === "string" && route.query.to) ||
      "";
    const isSafeInternalPath =
      requested.startsWith("/") &&
      !requested.startsWith("//") &&
      !requested.includes("\\");

    router.replace(isSafeInternalPath ? requested : { name: "UserProfile" });
  } catch (err) {
    console.error(err);

    const status = err?.response?.status;
    const body = err?.response?.data || {};

    if (status === 403 && body?.needs_verification) {
      clearAuthCookies();
      setVerifySessionFromApi(body, "login");
      persistIdentifier();
      showToast(body?.message || t("verify_account"), "info");
      router.replace({ name: "VerifyAccount" });
      return;
    }

    if (status === 403) {
      const msg = body?.message || t("login_error_invalid");
      errors.identifier = msg;
      showToast(msg, "error");
      return;
    }

    if (err?.response?.status === 422 && err?.response?.data?.errors) {
      const serverErrors = err.response.data.errors;

      errors.identifier =
        serverErrors.identifier?.[0] ||
        serverErrors.email?.[0] ||
        serverErrors.phone?.[0] ||
        "";

      errors.password = serverErrors.password?.[0] || "";

      const firstMsg =
        errors.identifier || errors.password || t("login_error_validation");

      showToast(firstMsg, "error");
      return; // عادي نرجع، finally راح يطفي اللودنق
    }

    const msg =
      err?.response?.data?.message || t("login_error_invalid");

    errors.identifier = msg;
    showToast(msg, "error");
  } finally {
    loading.value = false; // ✅ دائمًا تنطفي حتى لو صار return داخل catch
  }
}
</script>

<style scoped>
/* Direction follows document */
:global(html[dir="rtl"]) section {
  direction: rtl;
}
:global(html[dir="ltr"]) section {
  direction: ltr;
}
/* Layout */
.min-h-screen {
  min-height: 100vh;
}
.bg-slate-50 {
  background-color: #f8fafc;
}
.dark .bg-slate-900 {
  background-color: #0f172a;
}
.container {
  max-width: 1200px;
  margin-inline: auto;
  padding-inline: 1rem;
}
.grid {
  display: grid;
}
.gap-8 {
  gap: 2rem;
}

/* Sidebar */
aside {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.border {
  border-width: 1px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.p-5 {
  padding: 1.25rem;
}

/* Typography tweaks to match your utilities */
.text-slate-900 {
  --tw-text-opacity: 1 !important;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1)) !important;
}
.text-xl {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.mb-1 {
  margin-bottom: 0.25rem !important;
}
.text-center {
  text-align: center;
}
.text-primary {
  color: rgb(5 139 128 / 1);
}
.text-slate-500 {
  color: #64748b;
}
.text-slate-700 {
  color: #334155;
}
.dark .text-slate-200 {
  color: #e2e8f0;
}
.dark .text-slate-300 {
  color: #cbd5e1;
}
.font-semibold {
  font-weight: 600;
}
.font-bold {
  font-weight: 700;
}

/* Buttons */
button {
  transition: all 0.2s ease;
}
button:hover {
  opacity: 0.9;
}
button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.bg-primary {
  background-color: rgb(5 139 128 / 1);
}
.bg-secondary\/20 {
  background-color: rgb(199 159 63 / 0.2);
}
.bg-secondary\/30 {
  background-color: rgb(199 159 63/ 0.3);
}
.text-white {
  color: #fff;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}

/* Inputs */
input,
.BaseInput input {
  border-radius: 0.375rem;
  border: 1px solid #cbd5e1;
  padding: 0.5rem 0.75rem;
  width: 100%;
  background-color: #fff;
  color: #0f172a;
}
input:focus {
  border-color: rgb(5 139 128 / 1);
  outline: none;
}

/* Checkbox */
input[type="checkbox"] {
  accent-color: rgb(5 139 128 / 1);
}

/* Icons */
.mdi {
  font-size: 1rem;
  line-height: 1;
}

/* Animations */
.mdi-spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

/* Shadows */
.shadow-sm {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* Borders (Dark Mode) */
.dark .border-slate-700 {
  border-color: #334155;
}

/* Responsive */
@media (min-width: 768px) {
  .md\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .md\:col-span-4 {
    grid-column: span 4 / span 4;
  }
  .md\:col-span-8 {
    grid-column: span 8 / span 8;
  }
  .md\:p-8 {
    padding: 2rem !important;
  }
}
</style>
